import React, { useState, useEffect, useRef } from 'react';
import { SwatchesPicker } from 'react-color';
import reactCSS from 'reactcss';

import { head } from 'lodash';

import { GetForeColor } from '@libs/NwUtils';

const getTotalElements = (array2D) => {
    return array2D.reduce((total, row) => total + row.length, 0);
};

const SwatchPicker = ({
    value,
    foreColor,
    defaultColor,
    displayedLabel,
    colorsList,
    onChange,
    disabled,
    compact,
    placement = 'right',
}) => {
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColors] = useState(value ? value : '#000000');
    //serve solo con placement "left": ancora il popup alla posizione reale dello swatch, perche'
    //un position:fixed senza offset segue il suo punto nel flusso e sforerebbe a destra
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const swatchRef = useRef(null);

    let width = '400px';
    let height = '260px';
    const totalElements = getTotalElements(colorsList);
    if (totalElements > 50) {
        width = '640px';
    }

    useEffect(() => {
        setColors(defaultColor ? defaultColor : '#000000');
    }, [defaultColor, foreColor, disabled]);

    const handleClick = () => {
        if (!disabled) {
            if (placement === 'left' && swatchRef.current) {
                const rect = swatchRef.current.getBoundingClientRect();
                setPopoverAnchor({ top: rect.bottom, right: window.innerWidth - rect.right });
            }
            setDisplayColorPicker(true);
        }
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    const handleChange = (color) => {
        setColors(color.hex);
        onChange(color.hex);
    };

    const getTextColor = (color) => {
        if (foreColor) {
            return foreColor;
        }
        return GetForeColor(color);
    };

    const styles = reactCSS({
        default: {
            //variante "pallino": stessa interazione (click apre la palette), ingombro minimo per stare
            //in riga con altri campi invece che da sola in una riga di form verticale
            swatch: compact
                ? {
                      background: `${color}`,
                      borderRadius: '50%',
                      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                      display: 'inline-block',
                      cursor: 'pointer',
                      width: '2rem',
                      height: '2rem',
                  }
                : {
                      padding: '.75rem',
                      background: `${color}`,
                      borderRadius: '.5rem',
                      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                      display: 'inline-block',
                      cursor: 'pointer',
                      width: '12rem',
                      height: '3rem',
                  },
            label: {
                textAlign: 'center',
                whiteSpace: 'nowrap',
                textTransform: 'uppercase',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: `${getTextColor(color)}`,
            },
            popover: {
                position: 'fixed',
                zIndex: '2',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            },
        },
    });

    //con placement "left" il popup si ancora con top/right misurati: senza offset un fixed segue
    //il flusso e si apre verso destra, uscendo dalla finestra se lo swatch e' sul suo bordo
    const popoverStyle =
        placement === 'left' && popoverAnchor ? { ...styles.popover, ...popoverAnchor } : styles.popover;

    return (
        <div>
            <div ref={swatchRef} style={styles.swatch} onClick={handleClick}>
                {!compact && displayedLabel && <div style={styles.label}>{displayedLabel}</div>}
            </div>
            {displayColorPicker ? (
                <div style={popoverStyle}>
                    <div style={styles.cover} onClick={handleClose} />
                    <SwatchesPicker
                        colors={colorsList}
                        color={color}
                        onChange={handleChange}
                        width={width}
                        height={height}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default SwatchPicker;
